async function loadProducts() {
  let e = 1,
    t = !0;
  const o = {},
    n = new Map(),
    c = document.getElementById("color-metaobjects"),
    r = JSON.parse(c?.textContent || "{}"),
    a = getCurrentCollectionHandle();
  try {
    for (; t; ) {
      const c = await fetch(`/pages/meta_colors?page=${e}`);
      if (!c.ok) throw new Error(`HTTP Error: ${c.status}`);
      const s = await c.json(),
        l = s.products?.[0];
      if (!l || "object" != typeof l) break;
      for (const [e, { model: t, color: c }] of Object.entries(l)) {
        if (!e || !t || !c) continue;
        const r = a ? `/collections/${a}/products/${e}` : `/products/${e}`;
        (o[e] = { model: t, color: c }),
          n.has(t) || n.set(t, new Map()),
          n.get(t).set(c, { handle: e, url: r });
      }
      renderAllSwatches(o, n, r), (t = Boolean(s.has_more)), e++;
    }
  } catch (e) {
    console.error("Error cargando productos:", e);
  }
}
function renderAllSwatches(e, t, o) {
  const n = new Set(Object.keys(e));
  for (const c of n) {
    const n = e[c];
    if (!n) continue;
    const r = n.model,
      a = t.get(r);
    if (!a || 0 === a.size) continue;
    const s = document.querySelectorAll(
      `.grid__item .product-card-wrapper[data-handle="${c}"]:not([data-full-swatches-rendered])`
    );
    if (s.length) {
      for (const e of s) {
        const t = e.querySelector(".variant-option-swatcher");
        t && t.remove();
        const n = document.createElement("div");
        n.className = "json-contain tw-flex variant-option-swatcher";
        for (const [e, t] of a.entries()) {
          const c = o[e] || e,
            r = document.createElement("div");
          (r.className = "box-swatcher tw-cursor-pointer !tw-w-fit"),
            (r.onclick = () => (window.location.href = t.url));
          const a = document.createElement("div");
          (a.className = `value-color color--id-${e
            .toLowerCase()
            .replace(/\s+/g, "")}-${c.toLowerCase().replace(/\s+/g, "")}`),
            (a.innerHTML = "&nbsp;"),
            r.appendChild(a),
            n.appendChild(r);
        }
        const c = e.querySelector(".render-color-cs");
        c && c.appendChild(n);
      }
      s.forEach((e) => {
        const t = e.closest(".grid__item");
        t && t.setAttribute("data-full-swatches-rendered", "true");
      });
    }
  }
}
function getCurrentCollectionHandle() {
  const e = window.location.pathname.match(/\/collections\/([^/]+)/);
  return e ? e[1] : null;
}
document.addEventListener("DOMContentLoaded", () => {
  loadProducts();
});
/* Original assets -> custom-swatches-source -> */